module.exports = __webpack_public_path__ + "img/icon-note-gray.a4b64e35.svg";